export function setupCounters() {
    const counters = document.querySelectorAll('.counter');

    if(counters.length > 0) {
        Array.from(counters).forEach(counter => {           
            const addBtn = counter.querySelector('.add');
            const subBtn = counter.querySelector('.substract');
            let input = counter.querySelector('.amount');
            let min = 1;

            if(input.hasAttribute('data-min')) {
                min = parseInt(input.getAttribute('data-min'));
            }

            if(input) {
                addBtn.addEventListener('click', event => {
                    let value = parseInt(input.value);
                    value = add(value);
                    input.value = value;
                });

                subBtn.addEventListener('click', event => {
                    let value = parseInt(input.value);
                    value = substract(value, min);
                    input.value = value;
                });
            }
        })
    }
}

function add(value) {
    return value +1;
}

function substract(value, min) {
    if(value > min) {
        return value -1;
    }

    return value;
}
